// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import {environment as prod} from './environment.prod';
export const environment = {
  production: false,
  serverHost: 'https://dev-global.qform.io/v1/',
  ssoHost: 'https://dev-sso.qform.io/v1/',
  GTM_ID: '',
  version: prod.version + '_dev'
};
